<template>
	<div class="u-container">
		<SignupAgree
			v-if="!step || step === 1"
			@changeStep="changeStep"
		></SignupAgree>

		<SignupForm v-if="step === 2" @changeStep="changeStep"></SignupForm>
		<SignupResult v-if="step === 3"></SignupResult>
	</div>
</template>

<script>
import SignupAgree from './SignupAgree';
import SignupForm from './SignupForm';
import SignupResult from './SignupResult';

export default {
	components: {
		SignupAgree,
		SignupForm,
		SignupResult,
	},
	data() {
		return {
			step: 1,
		};
	},
	methods: {
		changeStep(step) {
			this.step = step;
		},
	},
};
</script>
